import { gql } from '@apollo/client';

export const GET_QUESTIONNAIRE_RESPONSE_BY_ID = gql`
  query GetQuestionnaireResponseById($id: ID!) {
    questionnaireResponse {
      questionnaireResponseById(id: $id) {
        id
        questionnaireId
        status
        patientId
        mainScoreMetric {
          metricDefinitionId
          id
          title
          createdAt
          components {
            score
            ... on GqlQuestionnaireObservationComponent {
              quantityValue: value {
                value
                unit
                system
                code
              }
              scoreDimensionMetadata {
                dimensionId
                dimensionName
                isPrimaryDimension
                isMainComponent
              }
            }
          }
        }
        subScoreMetrics {
          metricDefinitionId
          id
          title
          createdAt
          components {
            score
            ... on GqlQuestionnaireObservationComponent {
              quantityValue: value {
                value
                unit
                system
                code
              }
              scoreDimensionMetadata {
                dimensionId
                dimensionName
                isPrimaryDimension
                isMainComponent
              }
            }
          }
        }
        questionResponses {
          __typename
          questionId
          questionText
          questionType
          metric {
            components {
              score
              ... on GqlNumericObservationComponent {
                quantityValue: value {
                  value
                  unit
                  system
                  code
                }
              }
            }
          }
          score
          ... on GqlNumericQuestionResponse {
            decimalValue: value
          }
          ... on GqlScaleQuestionResponse {
            intValue: value
          }
          ... on GqlChoiceQuestionResponse {
            listOfAnswerOptionValue: value {
              id
              score
              coding {
                code
                display
                version
                system
              }
            }
          }
          ... on GqlOpenQuestionResponse {
            value
          }
          ... on GqlLikertQuestionResponse {
            answers {
              question {
                id
                text
              }
              answer {
                id
                score
                coding {
                  code
                  display
                  version
                  system
                }
              }
              score
            }
          }
          ... on GqlDateQuestionResponse {
            datetimeValue: value
            valueCognitiveTest {
              year
              month
              day
              dayOfWeek
            }
          }
        }
        questionStates {
          questionId
          status
        }
      }
    }
  }
`;
